<div class="account-no-companies flex flex-column align-items-center justify-content-center h-screen w-screen p-6 text-center">
    <i class="pi pi-building text-6xl text-error mb-4"></i>
    <h1 class="m-0 mb-3">{{ "ERROR.NO_COMPANIES_ASSIGNED.TITLE" | translate }}</h1>
    <p class="text-secondary m-0 mb-5">{{ "ERROR.NO_COMPANIES_ASSIGNED.DESCRIPTION" | translate }}</p>

    <p-button
        [label]="'HEADER.LOGOUT' | translate"
        icon="pi pi-sign-out"
        (onClick)="logout()"
    />
</div>
